import api from "@/lib/api";

export async function uploadTemplate(file, purpose, onProgress) {
  const extension = file.name.split(".").pop().toLowerCase();
  if (!["pdf", "png", "jpg", "jpeg"].includes(extension)) throw new Error("Choose a PDF, PNG or JPEG file");
  if (!file.size || file.size > 5 * 1024 * 1024) throw new Error("Choose a non-empty file no larger than 5MB");
  onProgress(0, "Preparing upload…");
  const { data: upload } = await api.post("/templates/uploads", { filename: file.name, size: file.size, purpose });
  for (let index = 0; index < upload.chunks; index++) {
    onProgress(Math.round(index / upload.chunks * 85), `Uploading part ${index + 1} of ${upload.chunks}…`);
    await api.put(`/templates/uploads/${upload.id}/chunks/${index}`, file.slice(index * upload.chunk_size, (index + 1) * upload.chunk_size), { headers: { "Content-Type": "application/octet-stream" } });
  }
  onProgress(90, "Validating and preparing preview…");
  const { data } = await api.post(`/templates/uploads/${upload.id}/complete`);
  onProgress(100, "Background ready");
  return data;
}

export function downloadBlob(data, filename) {
  const url = URL.createObjectURL(data); const link = document.createElement("a");
  link.href = url; link.download = filename; document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
